var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_47950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81087 4.79297L9.80576 19.0422C10.0638 19.6554 10.9332 19.6541 11.1893 19.0401L12.5635 15.7454L15.6591 18.841C16.5377 19.7197 17.9624 19.7197 18.841 18.841C19.7197 17.9623 19.7197 16.5377 18.841 15.659L15.7454 12.5634L19.0401 11.1892C19.6541 10.9331 19.6555 10.0637 19.0423 9.80568L4.79303 3.81081C4.17344 3.55014 3.5502 4.17338 3.81087 4.79297Z",
    fill: "#12131A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.041 13.1016L16.7197 17.7803C17.0126 18.0732 17.4875 18.0732 17.7804 17.7803C18.0733 17.4874 18.0733 17.0126 17.7804 16.7197L13.1016 12.0409L16.8103 10.494L5.9068 5.90674L10.4941 16.8103L12.041 13.1016ZM19.0401 11.1892C19.6541 10.9331 19.6555 10.0637 19.0423 9.80568L4.79303 3.81081C4.17344 3.55014 3.5502 4.17338 3.81087 4.79297L9.80576 19.0422C10.0638 19.6554 10.9332 19.6541 11.1893 19.0401L12.5635 15.7454L15.6591 18.841C16.5377 19.7197 17.9624 19.7197 18.841 18.841C19.7197 17.9623 19.7197 16.5377 18.841 15.659L15.7454 12.5634L19.0401 11.1892Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_47950",
    x: 0.75,
    y: 2.24994,
    width: 21.7515,
    height: 21.7514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_47950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_47950",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorDefault);
export default __webpack_public_path__ + "static/media/cursorDefault.28094138d49d4dd9acc73d39f985eaa1.svg";
export { ForwardRef as ReactComponent };